$(function(){
  $(document).on("change", ".rb-occupation-select",function(){
    var occupation_child = $(this).data('occupation-child') + Date.now()
    var child = $(this).parents('.rb-occupation-select-parent').next().find('.rb-occupation-select-child')
    child.attr('id', occupation_child)
    $.ajax({
      url: '/registrations/occupation_selects',
      type: 'GET',
      dataType: 'script',
      data: {
        parent_id: $(this).val(),
        name: $(this).data('name'),
        occupation_child: occupation_child
      }
    })
  })

})